module.exports = __webpack_public_path__ + "img/40_38_032_100.3de5af71.jpg";